var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"the-content"},[_c('h2',[_vm._v(_vm._s(_vm.introduction.subtitle))]),_c('p',[_vm._v(" "+_vm._s(_vm.introduction.overview)+" ")]),_c('span',{staticClass:"interaction-tip"},[_c('Icon',{attrs:{"icon":"interactive"}}),_c('span',{staticClass:"label"},[_vm._v("Select an option below to explore")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }